import { getNumberFromDate } from 'utils/dateUtil'

const date = new Date()
export const F_NUM = -1
export const F_STR = ''
export const F_YM = getNumberFromDate(date, 6)
export const F_YM_BEFORE = getNumberFromDate(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate()), 6)
export const F_ARR = []
